export function getDownloadDataFileName(instrumentMetadata, isIntraday) {
  return `Dashboard - ${instrumentMetadata?.name || instrumentMetadata?.id}${isIntraday ? "-Intraday" : ""}`
}

export const DOWNLOAD_SHEET_ORDER = {
  assets: 0,
  factors: 1,
  kpi: 2,
}
